import route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const Events = LazyloadWrapper(import('./Events'));

export default {
  RenderProp: Events,
  mainRoute: route,
};
